var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-lg flex flex-col leading-2"},[_c('p',{staticClass:"mb-6 text-xl font-bold text-gray-800"},[_vm._v("Please verify you are human.")]),_vm._v(" "),_c('vue-recaptcha',{attrs:{"sitekey":_vm.siteKey},on:{"verify":_vm.submitRecaptcha}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }